import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useState, useRef } from "react";
import './Route.css';

const empresas = [
  {
    id: 1,
    name: "CAMALEONICO PLACAS",
    dir: "Calle 63 # 13-61 Chapinero, Bogotá",
    ctg: "Placas decorativas y Accesorios",
    lat: 4.6584315,
    lng: -74.0740254,
    img: "./brands/camaleonico.png",
    ico: "https://dreadhome.com/wp-content/uploads/2021/06/ICONO-TIENDA-1.png",
    tel: "573177364386",
  },
  {
    id: 2,
    name: "DREADHOME",
    dir: "Calle 21 sur # 51 72, Puente Aranda, Bogotá",
    ctg: "Publicidad y Software",
    lat: 4.607220605610046,
    lng: -74.12413781468953,
    img: "https://dreadhome.com/wp-content/uploads/2021/06/dreadhome_favicon-150x150.png",
    ico: "https://dreadhome.com/wp-content/uploads/2021/06/ICONO-TIENDA-1.png",
    tel: "573012601164",
  },
  {
    id: 3,
    name: "RAS URBAN",
    dir: "Cra 19 # 56-80 SUR San Carlos, Bogotá",
    ctg: "Ropa y Accesorios",
    lat: 4.566498692286265,
    lng: -74.13438467593123,
    img: "https://dreadhome.com/wp-content/uploads/2021/06/logo-Ras-urban-final-150x150.jpg",
    ico: "https://dreadhome.com/wp-content/uploads/2021/06/ICONO-TIENDA-1.png",
    tel: "573151333093",
  },
];

function FlyTo({ position }) {
  const map = useMap();
  if (position) map.setView(position, 17);
  return null;
}

export default function MapEmpresas() {
  const markersRef = useRef({});
  const [center, setCenter] = useState(null);

  const icon = (url) =>
    L.icon({
      iconUrl: url,
      iconSize: [30, 30],
    });

  const openMarker = (id, lat, lng) => {
    markersRef.current[id]?.openPopup();
    setCenter([lat, lng]);
  };

  return (
    <div id="map_dh" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0 }}>
      {/* MAPA */}
      <MapContainer
        center={[4.64, -74.14]}
        zoom={11}
        style={{ height: 500, width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {empresas
          .filter((e) => e.lat && e.lng)
          .map((e) => (
            <Marker
              key={e.id}
              position={[e.lat, e.lng]}
              icon={icon(e.ico)}
              ref={(ref) => (markersRef.current[e.id] = ref)}
            >
              <Popup>
                {e.name} - {e.ctg}
              </Popup>
            </Marker>
          ))}
        <FlyTo position={center} />
      </MapContainer>

      {/* LISTADO */}
      <div className="table_entity">
        {empresas.map((e) => (
          <div key={e.id} className="crew">
            <img src={e.img} alt={e.name} width={80} />
            <div className="datos">
                <h3>
                {e.name} 
                </h3>
                <span>{e.ctg}</span>
                {e.dir && <p>{e.dir}</p>}
            </div>
            <div className="botones">
                {e.lat && (
                <button className="btn_cntct" onClick={() => openMarker(e.id, e.lat, e.lng)}>
                    Ver en el mapa
                </button>
                )}
                <a className="btn_cntct"
                href={`https://api.whatsapp.com/send?phone=${e.tel}&text=Hola, deseo hablar con ${e.name}`}
                target="_blank"
                rel="noreferrer"
                >
                    WhatsApp
                </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
